

<div class="fuse-card auto-width mat-card mb-12 p-0" *ngIf="isLoading">
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
        class="dis-block p-10">

        <div class="m-auto">
            <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
            </mat-progress-spinner>
        </div>

    </div>
</div>

<div *ngIf="!isLoading">
    <div class="fuse-card auto-width mat-card mb-12 p-0" *ngIf="coordinatorStatisticsService.isStatisticsHidden">
        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
            class="dis-block p-10">
    
            <div class="m-l-5">
                <p>La empresa seleccionada no tiene datos estadísticos para mostrar.</p>
            </div>
    
        </div>
    </div>
    
    <div *ngIf="!coordinatorStatisticsService.isStatisticsHidden">
        <app-company-comments></app-company-comments>
    
        <app-absenteeism-chart></app-absenteeism-chart>
    
        <app-kpi-grid></app-kpi-grid>
    
        <app-contacts></app-contacts>
    </div>
</div>

